import _default from './Tab';
export { _default as default };